import moment from "moment";

const currentDateTime = moment().format("YYYY-MM-DDTHH:mm:ss.SS");

export const containerRowTemplate = {
    id: 0,
    docksno: 0,
    lineseqno: 0,

    containernumber: "",
    sealnumber: "",
    marksno: "",

    contsize: "",
    contype: "",
    contypecode: "",
    contypename: "",

    tareweight: "",

    nopackage: 0,
    packagecode: "",
    packagedescription: "",

    scheduleb: "",
    descriptions: "",

    kgs: 0,
    lbs: 0,
    cbm: 0,
    cft: 0,

    riderpageno: 0,
    isdeleted: false,

    hazcode: "",
    manufacturer: "",
    country: "",
    itnumber: "",
    cncprsnumber: "",
    pickupnumber: "",

    lastdate: currentDateTime,

    netkgs: 0,
    netlbs: 0,

    containerparentid: 0,
    vinNumber: "",
    titleNumber: "",
    cargoState: "",

    importfromcargouniqueid: 0,

    createddate: currentDateTime,

    cargovalue: 0,
    valueofvehicle: 0,

    isappliedonmbl: false,
};
export const dockReceiptCargoDescription = [
    {
        "markssealno": "",
        "noofpacages": "",
        "haztype": "",
        "commoditydescription": "",
        "grossweight": "",
        "grossmeasurment": ""
    }
]

export const dockReceiptInitialValues = {
    docksno: 0,
    dockreceiptSeqno: 0,
    drnumber: "",
    bookingsno: 0,
    referencenumber: "",
    pointforigin: "",
    shipperid: 0,
    shipper: "",
    shipperaddress: "",
    consigneeid: 0,
    consignee: "",
    consigneeaddress: "",
    forwarderid: 0,
    forwarder: "",
    forwarderaddress: "",
    notifyid: 0,
    notify: "",
    notifyaddress: "",
    loadingpierterminal: "",
    totalcontainer: 0,
    totalpackage: 0,
    totallbs: "",
    totalkgs: "",
    totalcbm: "",
    totalcft: "",
    engMetricPrint: "",
    createdby: "",
    createdon: currentDateTime,
    modifyby: "",
    modifyon: currentDateTime,
    drdone: true,
    notautocalculate: false,
    grossweightUnit: "",
    issaved: true,
    isprintasownershipper: true,
    hidecneeonprint: true,
    hidenotifyonprint: true,
    islcManualdetails: true,
    headercommoditydescription: "",
    totalnetlbs: "",
    totalnetkgs: "",
    isprintgroupcommodities: true,
    isprintwithriderlist: true,

    dockReceiptContainer: [{ ...containerRowTemplate }],
    dockReceiptCargoDescription: dockReceiptCargoDescription,
};


export const packageTypeOptions = [
    { label: "SELECT PACKAGE TYPE", value: "" },
    { label: "BAG(S)", value: "BAG" },
    { label: "BALE(S)", value: "BAL" },
    { label: "BARREL(S)", value: "BBL" },
    { label: "BIN(S)", value: "BIN" },
    { label: "BOTTLE(S)", value: "BOT" },
    { label: "BOXE(S)", value: "BOX" },
    { label: "BUCKET(S)", value: "BXT" },
    { label: "BULK", value: "BLK" },
    { label: "BUNDLE(S)", value: "BDL" },
    { label: "CARTON(S)", value: "CTN" },
    { label: "CASE(S)", value: "CAS" },
    { label: "COIL(S)", value: "COL" },
    { label: "CONTAINER(S)", value: "CNT" },
    { label: "CRATE(S)", value: "CRT" },
    { label: "CYLINDER(S)", value: "CYL" },
    { label: "DRUM(S)", value: "DRM" },
    { label: "FIBER BIN(S)", value: "BIN" },
    { label: "FIBERBOARD BOX(S)", value: "BOX" },
    { label: "FLEXITANK(S)", value: "FL" },
    { label: "GAYLORD(S)", value: "GAY" },
    { label: "INGOT(S)", value: "IN" },
    { label: "KIT(S)", value: "KIT" },
    { label: "LIFTVAN(S)", value: "LTV" },
    { label: "LOOSE", value: "UNP" },
    { label: "LOT(S)", value: "LT" },
    { label: "MOTORCYCLE(S)", value: "MTR" },
    { label: "PACKAGE(S)", value: "PKG" },
    { label: "PAIL(S)", value: "PAL" },
    { label: "PALLET(S)", value: "PLT" },
    { label: "PIECE(S)", value: "PCS" },
    { label: "RACK(S)", value: "RCK" },
    { label: "REEL(S)", value: "REL" },
    { label: "ROLL(S)", value: "ROL" },
    { label: "SACK(S)", value: "SAK" },
    { label: "SHEET(S)", value: "SHT" },
    { label: "SKID(S)", value: "SKD" },
    { label: "SLIPSHEET(S)", value: "SLP" },
    { label: "SUPERSACK(S)", value: "SUK" },
    { label: "TANK(S)", value: "TNK" },
    { label: "TOTE(S)", value: "TBN" },
    { label: "TRUNK(S)", value: "TRK" },
    { label: "UNIT(S)", value: "UNT" },
    { label: "UNPACKED", value: "UNP" },
    { label: "VEHICLE(S)", value: "VHL" },
];



export const routingInformation = [
    {
        label: "Place Of Reciept:",
        name: "ourPlaceOfReceipt",
        type: "text",
        disabled: true,
    },
    {
        label: "Port Of Loading:",
        name: "portOfLoading",
        type: "text",
        disabled: true,
    },
    {
        label: "Port Of Discharge:",
        name: "portOfDischarge",
        type: "text",
        disabled: true,
    },
    {
        label: "Place Of Delivery:",
        name: "ourPlaceOfDelivery",
        type: "text",
        disabled: true,
    },
    {
        label: "Move Type:",
        name: "ourMoveType",
        type: "text",
        disabled: true,
    },
    { label: "Vessel", name: "vessel", type: "text", disabled: true },
    { label: "Carrier", name: "carrier", type: "text", disabled: true },
];
export const printBlOptions = [
    { label: "Both", value: "B" },
    { label: "Metric Only", value: "M" },
    { label: "English Only", value: "E" },
];

export const fileInformation = [
    { label: "Point (State) Of Origin:", name: "pointforigin", type: "text" },
    {
        label: "House BL Number:",
        name: "fileNumber",
        type: "text",
        disabled: true,
    },
    {
        label: "Customer Ref. #:",
        name: "customerReference",
        type: "text",
        disabled: true,
    },
];